import React from 'react';
import MuiGrid from '@material-ui/core/Grid';

const Row = (props) => {
  return <MuiGrid container {...props} />;
};
export default Row;
